import apiService from '../apiService';

const COMPANY_USER_URL = '/companies/user'
const SETTINGS_USER_URL = '/settings/users';
const userService = {

  async getAllUsers(params = {}) {
    try {
      const queryParams = new URLSearchParams(params).toString();
      const response = await apiService.get(`${SETTINGS_USER_URL}${queryParams ? `?${queryParams}` : ''}`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async getAllArchiveUsers(payload) {
    try {
      const queryParams = new URLSearchParams(payload).toString();
      const response = await apiService.get(`${SETTINGS_USER_URL}/trash?${queryParams}`,);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async updateUser(payload, id) {
    try {
      const response = await apiService.put(`${SETTINGS_USER_URL}/${id}`, payload);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async resetUser2FA(id) {
    try {
      const response = await apiService.patch(`${SETTINGS_USER_URL}/${id}/reset`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  // Welcome email again, with a fresh "set your password" link (OL-222).
  async sendWelcomeEmail(id) {
    try {
      const response = await apiService.post(`${SETTINGS_USER_URL}/${id}/welcome`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async restoreUser(id) {
    try {
      const response = await apiService.patch(`${SETTINGS_USER_URL}/restore/${id}`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async createSettingsUser(payload) {
    try {
      const response = await apiService.post(SETTINGS_USER_URL, payload);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async deleteSettingsUser(id) {
    try {
      const response = await apiService.delete(`${SETTINGS_USER_URL}/${id}`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async activateSettingsUser(id, payload = {}) {
    try {
      const response = await apiService.patch(`${SETTINGS_USER_URL}/${id}/activate`, payload);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async deactivateSettingsUser(id) {
    try {
      const response = await apiService.patch(`${SETTINGS_USER_URL}/${id}/deactivate`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async getSettingsSingleUser(id) {
    try {
      const response = await apiService.get(`${SETTINGS_USER_URL}/${id}`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  // New Payment flow affected apis
  async createUser(payload) {
    try {
      const response = await apiService.post(`${COMPANY_USER_URL}/create`, payload);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async deleteUser(id) {
    try {
      const response = await apiService.delete(`${COMPANY_USER_URL}/${id}/delete`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async ActivateUser(id, payload = {}) {
    try {
      const response = await apiService.patch(`${COMPANY_USER_URL}/${id}/activate`, payload);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async DeactivateUser(id) {
    try {
      const response = await apiService.patch(`${COMPANY_USER_URL}/${id}/disable`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async getSingleUser(id) {
    try {
      const response = await apiService.get(`${COMPANY_USER_URL}/show/${id}`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async getUserSubscription(id) {
    try {
      const response = await apiService.get(`/user-billing/${id}`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async getCompanyAddedUserPaymentInfo(id) {
    try {
      const response = await apiService.get(`/actual-amount/${id}`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  }
};

export default userService;
